export default {
  call: 'Llamar',
  text: 'Texto',
}
